import React from 'react';

const Img = ({alt, ...props}) => (
   <img alt={alt} {...props}/>
)

export default Img;